import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { selectConfiguration, selectSessionForStreamRef, selectStreamView } from '../ducks/we-spin-selectors.js';
import { SESSION_ONLINE } from '../constants/we-spin-stream-states.js';
import useContextualPathTransformer from '../../../../hooks/use-contextual-path-transformer.js';
import useQueryCodec from '../../../../hooks/use-query-codec.js';
import { useLocation } from 'react-router-dom';
import { useRouter } from '~/utils/navigation';

const useWeSpinGATracking = streamRef => {
	const router = useRouter();
	const location = useLocation();
	const { useWeSpinGATracking: weSpinGATracking } = useSelector(selectConfiguration);
	const { sessionState } = useSelector(selectSessionForStreamRef(streamRef)) || {};
	const { joined } = useSelector(selectStreamView(streamRef)) || {};
	const transformPath = useContextualPathTransformer();
	const { queryDecoder } = useQueryCodec();
	useEffect(() => {
		if (weSpinGATracking) {
			const { search, pathname } = queryDecoder(window.location) || {};
			if (pathname) {
				const currentParams = new URLSearchParams(search);
				currentParams.set('participant', joined);
				const live = sessionState === SESSION_ONLINE;
				currentParams.set('live', live);

				const newSearch = `?${currentParams.toString()}`;
				if (newSearch !== search) {
					// TODO (navigation) - use search params or redux for state
					router.push(transformPath(`${pathname}${newSearch}`), location.state);
				}
			}
		}
	}, [
		weSpinGATracking,
		joined,
		sessionState,
		router,
		location.pathname,
		transformPath,
		queryDecoder,
		location.state
	]); // location.pathname needed to trigger updates
};

export default useWeSpinGATracking;
